import { Suspense, lazy } from "react";
import { Skeleton } from "@fox1ck-org/ui";

const Monaco = lazy(() => import("@monaco-editor/react").then((m) => ({ default: m.default })));

// SnippetKind here is the canonical-mirror string union — the source of truth
// is `TagManagerSnippetKind` in `@gen/tracker/v1/tag_manager_pb`, but a
// proto enum is a number at runtime so callers translate before invoking the
// editor (see kindToMockShape in pages/tag-manager/list.tsx).
export type SnippetKind = "GTM" | "PIXEL" | "POSTBACK" | "CUSTOM_HTML" | "CUSTOM_JS";

const LANGUAGE: Record<SnippetKind, string> = {
  GTM: "html",
  PIXEL: "html",
  POSTBACK: "html",
  CUSTOM_HTML: "html",
  CUSTOM_JS: "javascript",
};

export function MonacoSnippetEditor({
  kind,
  value,
  onChange,
  height = 280,
}: {
  kind: SnippetKind;
  value: string;
  onChange: (next: string) => void;
  height?: number;
}) {
  return (
    <div className="rounded-md border border-border bg-card">
      <Suspense fallback={<Skeleton className="h-70 w-full" />}>
        <Monaco
          height={`${height}px`}
          language={LANGUAGE[kind]}
          value={value}
          onChange={(v) => onChange(v ?? "")}
          theme="vs-dark"
          options={{
            minimap: { enabled: false },
            fontSize: 12,
            fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
            scrollBeyondLastLine: false,
            wordWrap: "on",
            tabSize: 2,
            automaticLayout: true,
          }}
        />
      </Suspense>
    </div>
  );
}
